<agr-page-toolbar
  [isEmpty]="(barns$ | async)?.length === 0"
  [emptyTitle]="'no-barns-title' | translate"
  [emptyDescription]="'no-barns-description' | translate"
  emptyImage="assets/images/arrival.jpg"
  [hasPrimaryAction]="true"
  primaryActionIcon="add"
  [primaryActionText]="'add' | translate"
  (primaryAction)="add()"
  data-test="barn-overview"
>
  <ng-container *ngIf="(isLoading$ | async) === false && barns$ | async as barns">
    <mat-nav-list role="list" *ngIf="barns.length" class="barn-overview__list">
      <mat-list-item
        role="listitem"
        class="barn-item"
        data-test="barn-overview__item"
        *ngFor="let barn of barns"
      >
        <mat-icon matListItemAvatar class="list-avatar" svgIcon="mdi-barn"></mat-icon>
        <div matListItemTitle>{{ barn.name }}</div>
        <div matListItemLine class="text--gray">
          {{ barn.surfaceArea | agrNumber }} m2
          <span *ngIf="barn.animalGroupBarnIds !== undefined && barn.animalGroupBarnIds.length > 0">
            | {{ 'barn-item.animal-group-barn-id' | translate }}: {{ barn.animalGroupBarnIds }}
          </span>
        </div>
        <div matListItemMeta>
          <mat-slide-toggle
            [hideIcon]="true"
            style="padding-right: 30px"
            data-test="barn-overview__toggle-active"
            color="primary"
            labelPosition="before"
            [checked]="barn.isActive"
            (change)="onToggleActive(barn)"
          >
            <span class="text--small">{{ 'delivery-overview.active' | translate }}</span>
          </mat-slide-toggle>
          @if (brandingService.isTenant('Agravis')) {
            <button
              mat-flat-button
              class="tenant-icon-only-flat-button"
              color="primary"
              (click)="editBarn(barn)"
              data-test="barn-overview__edit-item"
            >
              <mat-icon>edit</mat-icon>
            </button>
            <button
              mat-flat-button
              class="tenant-icon-only-flat-button"
              color="primary"
              (click)="deleteBarn(barn)"
              data-test="barn-overview__delete-item"
            >
              <mat-icon>delete</mat-icon>
            </button>
          } @else {
            <button mat-icon-button (click)="editBarn(barn)" data-test="barn-overview__edit-item">
              <mat-icon>edit</mat-icon>
            </button>
            <button
              mat-icon-button
              (click)="deleteBarn(barn)"
              data-test="barn-overview__delete-item"
            >
              <mat-icon>delete</mat-icon>
            </button>
          }
        </div>
      </mat-list-item>
      <mat-divider *ngIf="barns.length > 0"></mat-divider>
    </mat-nav-list>
  </ng-container>
</agr-page-toolbar>

<div class="card spacing--margin-all">
  <agr-summary-card title="{{ 'animal-group.animalGroupTitle' | translate }}" [canExpand]="false">
    <div class="spacing--padding-all">
      <h6 class="text--h6">{{ 'animal-group.veterinarianTitle' | translate }}</h6>

      <div class="flex--column">
        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'animal-group.veterinarianTitle' | translate }}</mat-label>
          <mat-select
            [hideSingleSelectionIndicator]="true"
            placeholder="Veterinarian"
            [ngModel]="(veterinarianSettings$ | async)?.id"
            (selectionChange)="changeVeterinarianSelection($event)"
          >
            <mat-option [value]=""> </mat-option>
            <mat-option
              *ngFor="let veterinarian of veterinarians$ | async"
              [value]="veterinarian.id"
            >
              {{ veterinarian.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </agr-summary-card>
</div>
